import React from "react";
import { IconWithStyleProps } from "../../Types/types";

const IconWithStyle: React.FC<IconWithStyleProps> = ({
  IconComponent,
  type,
  isSelected,
  handleIconClick,
}) => {
  return (
    <IconComponent
      onClick={() => handleIconClick && handleIconClick(type)}
      className={`cursor-pointer transition-colors ${
        isSelected ? "text-purple" : "text-blue-gray-100 hover:text-gray-600 "
      }`}
    />
  );
};

export default IconWithStyle;
